import React, { Fragment } from 'react'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useHistory } from 'react-router-dom';

const styleModalConfirmacion = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
    p: 4, fontSize: '20px', textAlign: 'center'
};
function BotonRechazarDictamenComponent(props) {
    const history = useHistory();
    const [openModalConfirmarRechazoDictamen, setOpenModalConfirmarRechazoDictamen] = React.useState(false);
    const [dataRechazo, setDataRechazo] = React.useState([])

    const handleOpenModal = () => {
        setDataRechazo('')
        setOpenModalConfirmarRechazoDictamen(true)
    }
    const handleCloseModal= () => {
        setOpenModalConfirmarRechazoDictamen(false)
    }
    const ModalRechazoDictamen = () => {
        return (
            <Modal
                open={openModalConfirmarRechazoDictamen}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Rechazar Dictamen</h3>
                    Estás seguro de querer rechazar el dictamen?<br></br>
                    <button onClick={()=>rechazarDictamenes()} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }
    const rechazarDictamenes = () => {
        /*const dataSolicitud = {
            data: {
                idsolicitudesuifc01: Number(informacionCliente?.idsolicitudesuifc01),
                statusdelasolicitud: 6,
            }
        }
        /*dispatch(updateSolicitud(dataSolicitud))
        dispatch(obtenerSolicitudesUIFC01Estatus(5))*/
        handleCloseModal(/*history.push('/SolicitudesOrganismoComponent')*/)
        
    }
    return (
        <Fragment>
            <Tooltip title="Rechazar dictamen"><IconButton size="large" onClick={() => handleOpenModal()} > <HighlightOffIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
            {ModalRechazoDictamen()}
        </Fragment>
    )
}

export default BotonRechazarDictamenComponent